export function scrollAddClass() {
  document.addEventListener('DOMContentLoaded', localScrollAddClass);
  document.addEventListener('scroll', localScrollAddClass);
}

function localScrollAddClass() {
  const scrollEffect = document.querySelectorAll('.js-scroll');
  const delay = 200;
  let windowHeight = window.innerHeight - delay;
  for (let i = 0; i < scrollEffect.length; i++) {
    var target = scrollEffect[i].getBoundingClientRect().top;
    if (target < windowHeight) {
      scrollEffect[i].classList.add('is-active');
    }
  }
}